<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'OrderList' }">Orders</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-form 
      ref="order" 
      :model="order"
      :rules="rules.order"
      :label-position="label_position">

        <el-form-item label="First Name:" prop="customer_first_name">
            <el-input v-model="order.customer_first_name"></el-input>
        </el-form-item>

        <el-form-item label="Last Name:" prop="customer_last_name">
            <el-input v-model="order.customer_last_name"></el-input>
        </el-form-item>

        <el-form-item label="E-Mail:" prop="customer_email">
            <el-input v-model="order.customer_email"></el-input>
        </el-form-item>

        <el-form-item label="VAT Number:" prop="vat_number">
            <el-input v-model="order.vat_number"></el-input>
        </el-form-item>

        <el-form-item label="Billing Address 1:" prop="billing_address_1">
            <el-input v-model="order.billing_address_1"></el-input>
        </el-form-item>

        <el-form-item label="Billing Address 2:" prop="billing_address_2">
            <el-input v-model="order.billing_address_2"></el-input>
        </el-form-item>

        <el-form-item label="Billing Address 3:" prop="billing_address_3">
            <el-input v-model="order.billing_address_3"></el-input>
        </el-form-item>

        <el-form-item label="Billing City:" prop="billing_city">
            <el-input v-model="order.billing_city"></el-input>
        </el-form-item>

        <el-form-item label="Billing State:" prop="billing_state">
            <el-input v-model="order.billing_state"></el-input>
        </el-form-item>

        <el-form-item label="Billing Country:" prop="billing_country">
            <el-input v-model="order.billing_country"></el-input>
        </el-form-item>

        <el-form-item label="Billing Zip:" prop="billing_zip">
            <el-input v-model="order.billing_zip"></el-input>
        </el-form-item>

        <el-form-item label="Billing Telephone:" prop="billing_telephone">
            <el-input v-model="order.billing_telephone"></el-input>
        </el-form-item>

        <el-form-item label="Billing Mobile:" prop="billing_mobile">
            <el-input v-model="order.billing_mobile"></el-input>
        </el-form-item>

        <el-form-item label="Company Name:" prop="company_name">
            <el-input v-model="order.company_name"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Address 1:" prop="shipping_address_1">
            <el-input v-model="order.shipping_address_1"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Address 2:" prop="shipping_address_2">
            <el-input v-model="order.shipping_address_2"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Address 3:" prop="shipping_address_3">
            <el-input v-model="order.shipping_address_3"></el-input>
        </el-form-item>

        <el-form-item label="Shipping City:" prop="shipping_city">
            <el-input v-model="order.shipping_city"></el-input>
        </el-form-item>

        <el-form-item label="Shipping State:" prop="shipping_state">
            <el-input v-model="order.shipping_state"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Country:" prop="shipping_country">
            <el-input v-model="order.shipping_country"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Zip:" prop="shipping_zip">
            <el-input v-model="order.shipping_zip"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Telephone:" prop="shipping_telephone">
            <el-input v-model="order.shipping_telephone"></el-input>
        </el-form-item>

        <el-form-item label="Shipping Mobile:" prop="shipping_mobile">
            <el-input v-model="order.shipping_mobile"></el-input>
        </el-form-item>

        <el-form-item label="Purchase Order Number:" prop="purchase_order_number">
            <el-input v-model="order.purchase_order_number"></el-input>
        </el-form-item>

       <el-form-item>
          <el-button type="primary" @click="updateOrder('order')">Update</el-button>
        </el-form-item>
    </el-form>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>

</style>

<script>
import Config from '@/store/Config.js';
  export default {
    data: function() {
    return { 
        config: Config.config,
        page_alias: 'Edit Order',
        page_slug: 'edit-order',
        label_position: 'top',

        rules: {
          order: {
            customer_first_name: [
              { required: true, message: 'Please Enter First Name', trigger: 'blur' }
            ],
            customer_last_name: [
              { required: true, message: 'Please Enter Last Name', trigger: 'blur' }
            ],
            customer_email: [
              { required: true, message: 'Please Enter Email Address', trigger: 'blur' }
            ],
            vat_number: [
              { required: true, message: 'Please Enter VAT Number', trigger: 'blur' }
            ],
            billing_address_1: [
              { required: true, message: 'Please Enter Address 1', trigger: 'blur' }
            ],
            billing_address_2: [
              { required: true, message: 'Please Enter Address 2', trigger: 'blur' }
            ],
            billing_address_3: [
              { required: true, message: 'Please Enter Address 3', trigger: 'blur' }
            ],
            billing_city: [
              { required: true, message: 'Please Enter Billing City', trigger: 'blur' }
            ],
            billing_state: [
              { required: true, message: 'Please Enter Billing State', trigger: 'blur' }
            ],
            billing_country: [
              { required: true, message: 'Please Enter Shipping Country', trigger: 'blur' }
            ],
            billing_zip: [
              { required: true, message: 'Please Enter Shipping Zip Code', trigger: 'blur' }
            ],
            billing_telephone: [
              { required: true, message: 'Please Enter Phone Number', trigger: 'blur' }
            ],
            billing_mobile: [
              { required: true, message: 'Please Enter Mobile Number', trigger: 'blur' }
            ],
            company_name: [
              { required: true, message: 'Please Enter Company Name', trigger: 'blur' }
            ],
            shipping_address_1: [
              { required: true, message: 'Please Enter Shipping Address 1', trigger: 'blur' }
            ],
            shipping_address_2: [
              { required: true, message: 'Please Enter Shipping Address 2', trigger: 'blur' }
            ],
            shipping_address_3: [
              { required: true, message: 'Please Enter Shipping Address 3', trigger: 'blur' }
            ],
            shipping_city: [
              { required: true, message: 'Please Enter Shipping city', trigger: 'blur' }
            ],
            shipping_state: [
              { required: true, message: 'Please Enter Shipping State', trigger: 'blur' }
            ],
            shipping_country: [
              { required: true, message: 'Please Enter Shipping Country', trigger: 'blur' }
            ],
            shipping_zip: [
              { required: true, message: 'Please Enter Shipping Zip Code', trigger: 'blur' }
            ],
            shipping_telephone: [
              { required: true, message: 'Please Enter Shipping Phone', trigger: 'blur' }
            ],
            shipping_mobile: [
              { required: true, message: 'Please Enter Shipping Mobile Phone', trigger: 'blur' }
            ],
            purchase_order_number: [
              { required: true, message: 'Please Enter Purchase Order Number', trigger: 'blur' }
            ],
          }
        },

        order: {
            customer_first_name: '',
            customer_last_name: '',
            customer_email: '',
            vat_number: '',
            billing_address_1: '',
            billing_address_2: '',
            billing_address_3: '',
            billing_city: '',
            billing_state: '',
            billing_country: '',
            billing_zip: '',
            billing_telephone: '',
            billing_mobile: '',
            company_name: '',
            shipping_address_1: '',
            shipping_address_2: '',
            shipping_address_3: '',
            shipping_city: '',
            shipping_state: '',
            shipping_country: '',
            shipping_zip: '',
            shipping_telephone: '',
            shipping_mobile: '',
            purchase_order_number: ''
        },
      };
    },

    mounted: function() {
      const me = this;
      me.getOrder();
    },

    methods: {
      getOrder: function() {
        console.log('Get Order Function');
        const me = this;
        me.$http.get(me.config.api + 'order/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Success Getting Data')  
          console.log(response.status);
          console.log(response.statusText);

          me.order = response.body.data;
        }, response => {
          console.log('Error Getting Data');
          console.log(response.status);
          console.log(response.statusText);
        });
      },

      updateOrder: function(formName) {
        console.log('Update Order Function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            me.$http.put(me.config.api + 'order/{id}', me.order, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Success Putting Data')  
              console.log(response.status);
              console.log(response.statusText);
              me.getOrder();
              me.$notify({
                title: 'Success',
                message: 'The Order Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Error Putting Data');
              console.log(response.status);
              console.log(response.statusText);
              console.log(response.bodyText);
          });
          } else {
            console.log('Fields Not Valid');
            return false;
            }
        });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/orders/OrderEdit.vue